import React from 'react';
import { NotesRequiringApprovalList } from 'MessageCenter/NotesRequiringApproval';
import { NotesPendingActionList } from 'MessageCenter/NotesPendingAction';
// import { PeerReviewWorkCompList } from 'MessageCenter/PeerReview/WorkComp';
import { PeerReviewFederalList } from 'MessageCenter/PeerReview/Federal';
import { PeerReviewSpecialProgList } from 'MessageCenter/PeerReview/SpecialProg';
import { ProgressDueList } from 'MessageCenter/ProgressDue';
import { DischargeDueList } from 'MessageCenter/DischargeDue';
import { DiaryTasksList } from 'MessageCenter/DiaryTasks';
import { MCCategories, MCCategoryIds } from '_constants'

export class MessageList extends React.Component {
    render() {
        switch (this.props.selectedCategory) {
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.NOTES_REQUIRING_APPROVAL)].id:
                return (<NotesRequiringApprovalList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.NOTES_PENDING_ACTION)].id:
                return (<NotesPendingActionList />);
            // case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_WC)].id:
            //     return (<PeerReviewWorkCompList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_FEDERAL)].id:
                return (<PeerReviewFederalList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PEER_REVIEW_SPECIAL_PROG)].id:
                return (<PeerReviewSpecialProgList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.PROGRESS_DUE)].id:
                return (<ProgressDueList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.DISCHARGE_DUE)].id:
                return (<DischargeDueList />);
            case MCCategories[MCCategories.findIndex(obj => obj.id === MCCategoryIds.DIARY_TASKS)].id:
                return (<DiaryTasksList />);
            default:
                return (<NotesPendingActionList />);
        }
    }
}
